module.exports = __webpack_public_path__ + "img/fresh-food.710770b4.svg";